import * as React from 'react'

import { AsyncSelect, type IAsyncSelectProps } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { cardRepository } from '../../data-access/repositories/CardRepository'
import { Card } from '../../entities/Card'
import { CardStatuses } from '../../entities/enums/CardStatusEnum'

export interface IMyCardsSelectProps extends IAsyncSelectProps<Card> {}

export const MyCardsSelect = ({ ...props }: IMyCardsSelectProps) => {
  const intl = useProcurifyIntl()

  const loadOptions: IAsyncSelectProps<Card>['loadOptions'] = async (
    inputValue,
    pagination,
    callback
  ) => {
    const res = await cardRepository.getMyCards({
      status: CardStatuses.ACTIVE,
      requireActivation: false,
      params: { search: inputValue, page: pagination.page },
    })

    const data = res?.data || []

    callback({
      options: data.map((card) => new Card(card)),
      pagination: {
        hasMore: res?.pagination
          ? res.pagination?.page < res.pagination?.numPages
          : false,
        page: pagination.page + 1,
      },
    })
  }

  return (
    <AsyncSelect<Card>
      cacheOptions={true}
      loadOptions={loadOptions}
      placeholder={intl.formatMessage(messages.placeholderText)}
      getOptionLabel={(card) => `****${card.last4Digits}`}
      getOptionValue={(option) => (option ? option.id.toString() : '')}
      {...props}
    />
  )
}
